export const GET_BOM_APPROVALS = 'GET_BOM_APPROVALS';
export const GET_BOM_APPROVALS_SUCCESS = 'GET_BOM_APPROVALS_SUCCESS';
export const GET_BOM_APPROVALS_FAILED = 'GET_BOM_APPROVALS_FAILED';

export const GET_BOM_APPROVAL_BY_ID = 'GET_BOM_APPROVAL_BY_ID';
export const GET_BOM_APPROVAL_BY_ID_SUCCESS = 'GET_BOM_APPROVAL_BY_ID_SUCCESS';
export const GET_BOM_APPROVAL_BY_ID_FAILED = 'GET_BOM_APPROVAL_BY_ID_FAILED';

export const ACCEPT_REJECT_BOM_APPROVAL = 'ACCEPT_REJECT_BOM_APPROVAL';
export const ACCEPT_REJECT_BOM_APPROVAL_SUCCESS = 'ACCEPT_REJECT_BOM_APPROVAL_SUCCESS';
export const ACCEPT_REJECT_BOM_APPROVAL_FAILED = 'ACCEPT_REJECT_BOM_APPROVAL_FAILED';

export const SET_BOM_APPROVAL_PERMISSION = 'SET_BOM_APPROVAL_PERMISSION';
export const SET_BOM_APPROVAL_PERMISSION_SUCCESS = 'SET_BOM_APPROVAL_PERMISSION_SUCCESS';
export const SET_BOM_APPROVAL_PERMISSION_FAILED = 'SET_BOM_APPROVAL_PERMISSION_FAILED';

export const GET_BOM_APPROVAL_PERMISSION = 'GET_BOM_APPROVAL_PERMISSION';
export const GET_BOM_APPROVAL_PERMISSION_SUCCESS = 'GET_BOM_APPROVAL_PERMISSION_SUCCESS';
export const GET_BOM_APPROVAL_PERMISSION_FAILED = 'GET_BOM_APPROVAL_PERMISSION_FAILED';

export const DELETE_BOM_APPROVAL_PERMISSION = 'DELETE_BOM_APPROVAL_PERMISSION';
export const DELETE_BOM_APPROVAL_PERMISSION_SUCCESS = 'DELETE_BOM_APPROVAL_PERMISSION_SUCCESS';
export const DELETE_BOM_APPROVAL_PERMISSION_FAILED = 'DELETE_BOM_APPROVAL_PERMISSION_FAILED';
